import api from './api';

const auditService = {
  // Get audit logs with optional filters
  getLogs: async (params = {}) => {
    const response = await api.get('/audit/logs', { params });
    return response.data;
  },

  // Export logs (future feature)
  exportLogs: async (params = {}) => {
    const response = await api.get('/audit/logs/export', {
      params,
      responseType: 'blob'
    });
    return response.data;
  }
};

export default auditService;
